import region from '../../../utils/region.js'
import {
  BURYATIA,
  CHUVA,
  CRIMEA,
  HMAO,
  KALUG,
  KARELIA,
  KRASNODAR,
  KURGAN,
  KURSK,
  MARIEL,
  ORENB,
  PRIMOR,
  PSCOV,
  SAAS,
  SAHALIN,
  TATAR,
  VOLGOGRAD,
  YANAO,
  LEN,
  TAMBOV,
  TULA,
  SARATOV,
  KAMCHATKA
} from '@/config/region';
import MENU_BURYATIA from "./region.buryatia";
import MENU_DEFAULT from "./region.default"
import MENU_HMAO from "./region.hmao"
import MENU_CHUVA from "./region.chuva"
import MENU_KALUG from "./region.kalug"
import MENU_KARELIA from "./region.karelia"
import MENU_KRASNODAR from "./region.krasnodar"
import MENU_KURGAN from "./region.kurgan"
import MENU_KURSK from "./region.kursk"
import MENU_MARIEL from "./region.mariel"
import MENU_ORENB from "./region.orenb"
import MENU_PRIMOR from "./region.primor";
import MENU_PSCOV from "./region.pscov"
import MENU_SAAS from "./region.saas"
import MENU_SAHALIN from "./region.sahalin";
import MENU_TATAR from "./region.tatar"
import MENU_VOLGOGRAD from './region.volgograd'
import MENU_YANAO from "./region.yanao";
import MENU_CRIMEA from './region.crimea';
import MENU_LEN from './region.len';
import MENU_TAMBOV from './region.tambov';
import MENU_TULA from './region.tula';
import MENU_SARATOV from './region.saratov';
import MENU_KAMCHATKA from './region.kamchatka';

let _MENU_ITEMS = {
  [BURYATIA]: MENU_BURYATIA,
  [CHUVA]: MENU_CHUVA,
  [CRIMEA]: MENU_CRIMEA,
  [HMAO]: MENU_HMAO,
  [KALUG]: MENU_KALUG,
  [KARELIA]: MENU_KARELIA,
  [KRASNODAR]: MENU_KRASNODAR,
  [KURGAN]: MENU_KURGAN,
  [KURSK]: MENU_KURSK,
  [MARIEL]: MENU_MARIEL,
  [ORENB]: MENU_ORENB,
  [PRIMOR]: MENU_PRIMOR,
  [PSCOV]: MENU_PSCOV,
  [SAAS]: MENU_SAAS,
  [SAHALIN]: MENU_SAHALIN,
  [TATAR]: MENU_TATAR,
  [VOLGOGRAD]: MENU_VOLGOGRAD,
  [YANAO]: MENU_YANAO,
  [LEN]: MENU_LEN,
  [TAMBOV]: MENU_TAMBOV,
  [TULA]: MENU_TULA,
  [SARATOV]: MENU_SARATOV,
  [KAMCHATKA]: MENU_KAMCHATKA,

  default: MENU_DEFAULT,
}

export const MENU_ITEMS = region.getRegionConfig(_MENU_ITEMS)
